import { createSelector } from 'reselect';
import getDocumentById from './getDocumentById';

const getFinishFromLayer = createSelector(
    [getDocumentById],
    (layer) => layer?.finishes?.map((finish) => finish.id) ?? [],
);

export default getFinishFromLayer;
